import { isChannel } from './isChannel';

export const isValidChannelIndex = (indexToCheck) => ({ index, kind }) =>
  index === indexToCheck && isChannel({ kind });
